// // Use $ instead of jQuery without replacing global $
(function ($) {
    /*
     * Hero slider
     */
    $(document).ready(function () {
        if($('.banner-hero').length > 0) {
            $('.banner-hero .slider-wrapper').slick({
                draggable: true,
                arrows: false,
                dots: true,
                fade: true,
                speed: 900,
                dotsClass: 'custom-dots',
                infinite: true,
                autoplay: true,
                pauseOnDotsHover: false,
                focusOnSelect: true,
                pauseOnFocus: false,
                pauseOnHover: false,
                cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
            });
        }
    });
    $(window).on('load resize', function () {
        if($('.banner-hero').length > 0) {
            var slideSingle = $('.banner-hero .slider-wrapper .slider').length;
            if (slideSingle <= 1) {
                $('.banner-hero .custom-dots').hide();
            } else {
                $('.banner-hero .custom-dots').show();
            }
        }
    });
})(jQuery);